import {
    getAccessibilityTextData,
    getAssetsData,
    getConfigData,
    getDisplayTextData,
    getPlaceholderAssetsData,
} from './occContextConfigData'


import { InititialiseDataFromBe } from './types'
import {  NestedPartial } from '@vista/omnichannel-components-domain'
import { OccContextPropsWithoutDomainConfig } from '@vista/omnichannel-components-ui'

type OccContextConfig = Omit<OccContextPropsWithoutDomainConfig, 'children'>

declare global {
    interface Window {
        occContextConfig: Omit<OccContextConfig, 'subcomponents'>
    }
}

export function contextData(props: NestedPartial<InititialiseDataFromBe>): void {
    const {
        accessibilityText,
        assets,
        film,
        locale,
        displayText,
        security,
    }: NestedPartial<InititialiseDataFromBe> = props

    const occContextConfig: Omit<OccContextConfig, 'subcomponents'> = {
        excludeDomainConfig: true,
        accessibilityText: getAccessibilityTextData({ accessibilityText }),
        assets: getAssetsData({ assets }),
        config: getConfigData({ film, locale, security }),
        displayText: getDisplayTextData({ displayText }),
        placeholderAssets: getPlaceholderAssetsData(),
        //subcomponents: getSubcomponentsData(),
        //domain: undefined,
    }

    window.occContextConfig = occContextConfig
}

export default contextData